import type { CookieKey } from "../native-modules/types/RNCoreNativeModule";

import React, { createContext, useContext } from "react";

export type CookiesRecord<K extends CookieKey = CookieKey> = Partial<Record<K, string | null>>;

const CookiesContext = createContext<CookiesRecord | null>(null);

export function useCookies<K extends CookieKey = CookieKey>(): CookiesRecord<K> {
  const context = useContext(CookiesContext);
  if (!context) {
    throw new Error("CookiesContext used without initialization");
  }
  return context as CookiesRecord<K>;
}

export function CookieProvider<K extends CookieKey>({
  cookies,
  children,
}: {
  cookies: CookiesRecord<K>;
  children: React.ReactNode;
}) {
  return <CookiesContext.Provider value={cookies}>{children}</CookiesContext.Provider>;
}
